import { Button } from "@/components/shared/button";
import { Card, CardContent, CardFooter } from "@/components/shared/card";
import { Badge } from "@/components/shared/badge";

interface AssessmentCardProps {
  title: string;
  description: string;
  hasAssessment: boolean;
  viewPath: string;
  startPath: string;
  isComingSoon?: boolean;
  onClick?: () => void;
  customButtonText?: string;
}

export function AssessmentCard({
  title,
  description,
  hasAssessment,
  isComingSoon,
  onClick,
  customButtonText
}: AssessmentCardProps) {
  return (
    <Card className="relative flex flex-col min-h-[280px]">
      <CardContent className="flex-1 pt-6">
        <div className="flex justify-between items-start mb-4">
          <h3 className="text-xl font-semibold">{title}</h3>
          {isComingSoon && (
            <Badge variant="secondary" className="bg-gray-100">
              Coming Soon
            </Badge>
          )}
        </div>
        <p className="text-gray-600">{description}</p>
      </CardContent>
      <CardFooter className="mt-auto">
        <Button
          className="w-full"
          onClick={onClick}
          disabled={isComingSoon}
        >
          {customButtonText || (hasAssessment ? "View Assessment" : "Start Assessment")}
        </Button>
      </CardFooter>
    </Card>
  );
}